import './TaskLink.scss'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Icon from 'react-fa'
import classNames from 'classnames'
import RemoveButton from '../RemoveButton'
import Link from '../Link'

const TaskLink = props => {

  const { taskLink, allowDelete, deleteTaskLink, localize } = props
  const linkName = taskLink.name ? taskLink.name : taskLink.url
  const deleteLink = () => deleteTaskLink(taskLink.id)
  const removeTitle = localize('taskBoards.Label_DeleteTaskLink')
  return (
    <div className='task-link-row'>
      <Link className='task-link' href={taskLink.url} target='_blank' title={taskLink.url} >
        <Icon className='task-link__attachment-icon' name='paperclip' />
        {linkName}
      </Link>
      { allowDelete && <RemoveButton className='remove-link-button' title={removeTitle} onClick={deleteLink} /> }
    </div>
  )
}

TaskLink.propTypes = {
  taskLink: PropTypes.object.isRequired,
  deleteTaskLink: PropTypes.func.isRequired,
  allowDelete: PropTypes.bool.isRequired,
  localize: PropTypes.func.isRequired
}

export default TaskLink



// WEBPACK FOOTER //
// ./src/components/TaskDetails/TaskLink.js